import { decamelizeKeys } from 'humps';

import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';
import { parseQuery } from '@/utils/query';

export const http = createDashHttpClient(env.collaborationApiUrl, {
  camelizeKeys: true,
  decamelizeRequests: true,
});

export async function getNotifications({ next, isRead } = {}, config = {}) {
  const params = parseQuery(next, { limit: 20, isRead });
  return http.get(`/notifications`, { params }, config);
}

export async function updateNotification({ id, readAt }, config = {}) {
  const url = `/notifications/${id}`;
  return http.patch(url, { readAt }, config);
}

export async function updateNotifications({ ids, readAt }, config = {}) {
  const url = `/notifications`;
  return http.patch(url, { readAt }, { ...config, params: { ids } });
}

export async function getComments({ brandIds, resourceId, resourceType, limit }, config = {}) {
  const url = `/comments`;
  return http.get(url, {
    ...config,
    params: { brandIds, resourceId, resourceType, limit },
  });
}

export async function createComment(
  { brandId, resourceId, resourceType, text, parentId, meta },
  config = {},
) {
  return http.post(
    `/comments`,
    {
      brandId,
      resourceId,
      resourceType,
      text,
      parentId,
      meta,
    },
    config,
  );
}

export async function updateComment({ id, text, meta }, config = {}) {
  const url = `/comments/${id}`;
  return http.patch(url, { text, meta }, config);
}

export async function deleteComment({ id }, config = {}) {
  const url = `/comments/${id}`;
  return http.delete(url, config);
}

export async function getBrandComments(
  {
    brandIds,
    commentId,
    createdAfter,
    createdBefore,
    resourceIds,
    resourceTypes,
    mentionedUserIds,
    meta,
    offset,
    limit,
    sort,
    next,
  },
  config = {},
) {
  if (next) {
    return http.get(next, { ...config });
  }
  const url = `/comments`;
  return http.get(url, {
    params: {
      brandIds,
      commentId,
      createdAfter,
      createdBefore,
      resourceIds,
      resourceTypes,
      mentionedUserIds,
      meta: JSON.stringify(decamelizeKeys(meta)),
      offset,
      limit,
      sort,
    },
    ...config,
  });
}

export async function getCommentCounts(
  { brandIds, resourceType, meta, createdAfter, createdBefore, mentionedUserIds },
  config = {},
) {
  const url = `/comments/counts`;
  return http.get(url, {
    params: {
      brandIds,
      resourceType,
      meta: JSON.stringify(decamelizeKeys(meta)),
      createdAfter,
      createdBefore,
      mentionedUserIds,
    },
    ...config,
  });
}
